<script setup lang="ts">
defineProps<{
  scrollHeight?: string;
}>();
</script>

<template>
  <div
    class="z-50 grid w-full place-content-center"
    :style="{ height: scrollHeight }"
  >
    <i class="pi pi-spin pi-spinner text-[2rem] text-brand-500"></i>
  </div>
</template>
